import React, { memo, useEffect, useState } from 'react';
import { db,collection,onSnapshot,} from '../../config/firebase';
import * as XLSX from 'xlsx';
import { Button } from 'antd';
const PaymentDownload = () => {
    const [data, setData] = useState([]);
  
    useEffect(() => {


      const q = collection(db, "Payment");
    onSnapshot(q, (snapshot) => {
      const newData = [];
      snapshot.forEach((doc) => {
        newData.push(doc.data());
      });
      setData(newData);
    });
  }, []);

    const exportToExcel = () => {
      const workbook = XLSX.utils.book_new();
      const worksheet = XLSX.utils.json_to_sheet(data);

      XLSX.utils.book_append_sheet(workbook, worksheet, 'Payment Verify Detail');

      XLSX.writeFile(workbook, 'Payment Verify Detail.xlsx');
    };
  
    return (
      <div>
        <Button  onClick={exportToExcel}>Export to Excel</Button>
      </div>
    );
  };
  
  export default memo(PaymentDownload);
  